import { Input } from '@angular/core';
import { ChangeDetectorRef, Component, OnInit, ViewChild, Injectable, NgModule } from '@angular/core';
import { MatSort, Sort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { BehaviorSubject } from 'rxjs';
import { DevicePilomat } from '../model/devicePilomat';
import { LogEvent } from '../model/logEvent';
import { DeviceService } from '../service/device.service';
import { Log } from '../util/log';
import { FormControl } from "@angular/forms";
import { DateHelper } from '../util/dateHelper';
import { MatRadioGroup, MatRadioButton } from '@angular/material/radio';
import { MatPaginator, PageEvent } from '@angular/material/paginator';
import { MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { Subject } from 'rxjs';
import { NumberLiteralType } from 'typescript';
import { DateAdapter } from '@angular/material/core';
import { AppComponent } from '../app.component';
import { StringHelper } from '../util/stringHelper';

@Component({
  selector: 'app-device-log',
  templateUrl: './device-log.component.html',
  styleUrls: ['./device-log.component.css']
})
export class DeviceLogComponent implements OnInit {

  @Input() device: DevicePilomat;
  @ViewChild('logloader', { static: true }) loader;
  @ViewChild('logtable', { static: true }) table;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;

  fromFormControl: FormControl;
  toFormControl: FormControl;
  logDateTo: Date;
  logDateFrom: Date;
  showDatePickers: Boolean = false;
  displayedColumns: string[] = ['date', 'name', 'event', 'active'];

  logList: LogEvent[];
  dataSource: MatTableDataSource<LogEvent>;
  filterString: string = "";

  pageEvent: PageEvent;
  pageSize: number = 200;
  maxPages: number = 0;
  pageLength: number = 0;
  tableItemsTotalCounter: number = 0;
  pageSizeOptions: number[] = [200];
  currentPage: number = 0;

  pickedTimeRangeValue: string = "1";

  deviceLogString = $localize`:@@device_log_device_log: Log dispositivo`;
  accessLogString = $localize`:@@device_log_access_log: Registro accessi`;
  automationsLogString = $localize`:@@device_log_automations_log: Registro automatismi`;

  constructor(
    public appComponent: AppComponent,
    private deviceService: DeviceService,
    private cdRef: ChangeDetectorRef,
    private dateAdapter: DateAdapter<any>) {
    this.dateAdapter.setLocale($localize`:@@devicelog_datepicker_locale:it`);

  }

  ngOnInit() {

  }

  ngAfterViewInit() {

    this.logDateTo = new Date();
    this.logDateFrom = new Date();
    this.logDateTo.setHours(23, 59);
    this.logDateFrom.setHours(0, 0);

    this.toFormControl = new FormControl(this.logDateTo);
    this.fromFormControl = new FormControl(this.logDateFrom);

    setTimeout(() => {

      // this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo));
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    });
  }

  setLogTimeRange(picked: any) {
    this.pickedTimeRangeValue = picked.value;

    if (picked.value == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();
      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

      // +(this.logDateFrom.getTimezoneOffset()/60).toString()
      // +(this.logDateTo.getTimezoneOffset()/60).toString()

      Log.debug(DateHelper.formatDateForApi(this.logDateFrom));
      Log.debug(this.logDateFrom.getTimezoneOffset());
      Log.debug(DateHelper.formatDateForApi(this.logDateTo))
      Log.debug(this.logDateTo.getTimezoneOffset())
    } else if (picked.value == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);
      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

      Log.debug(DateHelper.formatDateForApi(this.logDateFrom));
      Log.debug(DateHelper.formatDateForApi(this.logDateTo))
    } else if (picked.value == "3") {
      this.showDatePickers = true;
    }
  }



  refreshData() {
    this.loader.showLoading();

    if (this.pickedTimeRangeValue == "1") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);

      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (this.pickedTimeRangeValue == "2") {
      this.logDateTo = new Date();
      this.logDateFrom = new Date();

      this.logDateTo.setDate(this.logDateTo.getDate() - 1);
      this.logDateFrom.setDate(this.logDateFrom.getDate() - 1);

      this.logDateTo.setHours(23, 59, 59);
      this.logDateFrom.setHours(0, 0, 0);

      this.showDatePickers = false;
      this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);
    } else if (this.pickedTimeRangeValue == "3") {
      this.confirmDateSelection();
    }
  }

  confirmDateSelection() {
    Log.debug("Dates confirmed");

    if (this.fromFormControl.value) {
      this.logDateFrom = new Date(this.fromFormControl.value);
    }
    if (this.toFormControl.value) {
      this.logDateTo = new Date(this.toFormControl.value);
    }

    this.logDateTo.setHours(23, 59, 59)
    this.logDateFrom.setHours(0, 0, 0)

    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), 0);

  }

  onKey(event: any) {

    this.filterString = event.target.value;

    this.table.dataSource.filter = this.filterString.trim().toLowerCase();
  }

  filterTable(data: LogEvent, filter: string): boolean {
    if (data.name && data.name.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.type && data.type.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.dataType && data.dataType.toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    if (data.value && data.value.toString().toLowerCase().indexOf(filter) != -1) {
      return true;
    }
    return false;
  }

  isService(): boolean {
    return this.appComponent.isService();
  }


  loadData(dateFrom: string, dateTo: string, page: number) {

    this.loader.showLoading();
    this.currentPage = page;

    this.deviceService.getLogCount(this.device.serial, dateFrom, dateTo).subscribe(data => {

      this.tableItemsTotalCounter = data.count;
      this.maxPages = Math.ceil(data.count / this.pageSize);

      Log.debug("getLogCount - tableItemsTotalCounter:  " + this.tableItemsTotalCounter + "  maxPages:" + this.maxPages);

      const obs = this.deviceService.getLogWithDate(this.device.serial, dateFrom, dateTo, page);
      obs.subscribe(data => {


        if (this.isService()) {
          // se è service censuro le informazioni relative ai metodi d'accesso
          for (let i = 0; i < data.length; i++) {
            if (data[i].type == "open-result"  && this.openResultToCensor(data[i].dataType)) {
              data[i].value = this.censorStringParentheses(data[i].value);
            }
          }
        }

        this.logList = data;

        this.table.dataSource = new MatTableDataSource(this.logList);
        this.table.dataSource.filterPredicate = this.filterTable;
        this.table.dataSource.sort = this.sort;
        this.table.dataSource.filter = this.filterString.trim().toLowerCase();
        this.cdRef.detectChanges();

        this.loader.hideLoading();

      }, error => {

        this.loader.hideLoading();
        this.loader.showError();
      });

    });
  }

  openResultToCensor(dataType) {
    if (dataType == "pincode-err") {
      return false;
    } else if (dataType == "open-ignored-forced-low") {
      return false;
    } else if (dataType == "open-ignored-app-not-enabled") {
      return false;
    } else {
      return true;
    }
  }

  censorStringParentheses(input): string {
    // Match everything inside the parentheses, including the last word
    input = String(input);

    const regex = /\((.*)\)/;
    const match = input.match(regex);

    if (match && match[1]) {
      // Extract the content inside parentheses
      let insideParentheses = match[1];

      // Split the content into words
      let words = insideParentheses.trim().split(' ');

      // Get the last word before the closing parenthesis
      let lastWord = words[words.length - 1];

      // Apply the custom function (e.g., halve the letters)
      let modifiedWord = StringHelper.censorString(lastWord);

      // Replace the original last word with the modified one
      words[words.length - 1] = modifiedWord;

      // Reconstruct the string inside parentheses and put it back into the original string
      insideParentheses = words.join(' ');
      return input.replace(match[1], insideParentheses);
    }

    // Return the input unchanged if no match found
    return input;
  }

  censorStringLastWord(input): string {
    // Match everything inside the parentheses, including the last word
    input = String(input);

    // Split the content into words
    let words = input.trim().split(' ');

    // Get the last word before the closing parenthesis
    let lastWord = words[words.length - 1];

    // Apply the custom function (e.g., halve the letters)
    let modifiedWord = StringHelper.censorString(lastWord);

    // Replace the original last word with the modified one
    words[words.length - 1] = modifiedWord;

    // Reconstruct the string inside parentheses and put it back into the original string
    input = words.join(' ');
    return input.replace(lastWord, modifiedWord);
  }

  changePage(event?: PageEvent) {

    Log.debug("changePage - pageIndex:  " + event.pageIndex);

    this.currentPage = event.pageIndex;
    this.loadData(DateHelper.formatDateForApi(this.logDateFrom), DateHelper.formatDateForApi(this.logDateTo), this.currentPage);
  }

}

